export const ROUTES_TYPES = {
  LOAD_ROUTES: "LOAD_ROUTES",
  SET_ROUTES: "SET_ROUTES",
  CLEAR_ROUTES: "CLEAR_ROUTES",
  // new route
  NEW_ROUTE: "NEW_ROUTE",
  SEND_NEW_ROUTE: "SEND_NEW_ROUTE",
  SET_NEW_ROUTE: "SET_NEW_ROUTE",

  EDIT_ROUTE: "EDIT_ROUTE",
  SET_EDITED_ROUTE: "SET_EDITED_ROUTE",
  DELETE_ROUTE: "DELETE_ROUTE",
  HANDLE_ROUTES_BUILDINGS_INPUTS: "HANDLE_ROUTES_BUILDINGS_INPUTS"
};
